import { render, staticRenderFns } from "./ProceduresInitTable.vue?vue&type=template&id=2b0a3264"
import script from "./ProceduresInitTable.vue?vue&type=script&lang=js"
export * from "./ProceduresInitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports